import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@personic/shared'

/**
 * Guards all consumer routes.
 * - Unauthenticated → redirect to personicai.com/auth/signin
 * - Non-consumer role → same redirect
 * - Initializing → show loading spinner
 */
export default function ConsumerAuthGuard() {
  const { user, isAuthenticated, isInitializing } = useAuthStore()
  const location = useLocation()

  // Attempt cookie-based session restore on first load
  useEffect(() => {
    if (!isAuthenticated && !isInitializing) {
      useAuthStore.getState().refresh?.()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (isInitializing) {
    return (
      <div className="min-h-screen bg-identity-dark flex items-center justify-center">
        <div className="animate-pulse text-identity-primary text-lg font-medium">
          Loading…
        </div>
      </div>
    )
  }

  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to={`https://personicai.com/auth/signin?redirect=${encodeURIComponent(location.pathname)}`}
        replace
      />
    )
  }

  if (user.role !== 'consumer') {
    // Non-consumer users (e.g., B2B employees who hit this domain) → marketing login
    window.location.href = 'https://personicai.com/auth/signin'
    return null
  }

  return <Outlet />
}
